import * as z from "zod";
import { ShopperAgentConfigVersionMetaSchema } from "./shopper-agent-config-version-meta";

/**
 * Replaces the current draft with a copy of an earlier version. Publishing
 * the reverted state is a separate, explicit publishShopperAgentConfig call.
 */
export const revertShopperAgentConfig = {
  name: "revertShopperAgentConfig" as const,
  input: z.object({ versionId: z.string() }),
  output: z.object({ version: ShopperAgentConfigVersionMetaSchema }),
};
